import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, ToastController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserProvider } from 'src/app/services/user/user';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.page.html',
  styleUrls: ['./alterar-senha.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class AlterarSenhaPage implements OnInit {
  validations_form: FormGroup;
  erro_senha: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private translate: TranslateService,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
  ) {
    this.validations_form = this.formBuilder.group({
      senhaatual: new FormControl('', Validators.compose([
        Validators.required
      ])),
      senha: new FormControl('', Validators.compose([
        Validators.minLength(6),
        Validators.required
      ])),
      confirmaSenha: new FormControl('', Validators.compose([
        Validators.minLength(6),
        Validators.required
      ])),
    });
  }

  ngOnInit() {
  }

  validation_messages = {
    'senhaatual': [
      { type: 'required', message: this.translate.instant('A senha deve ser informada') }
    ],
    'senha': [
      { type: 'required', message: this.translate.instant('A senha deve ser informada') },
      { type: 'minlength', message: this.translate.instant('A senha deve conter no mínimo 6 caracteres') },
    ],
    'confirmaSenha': [
      { type: 'required', message: this.translate.instant('A senha deve ser informada') },
      { type: 'minlength', message: this.translate.instant('A senha deve conter no mínimo 6 caracteres') },
    ]
  };

  async onSubmit(form: { senha: any; confirmaSenha: any; senhaatual: any; }): Promise<void> {
    if (form.senha !== form.confirmaSenha) {
      this.erro_senha = true;
      return;
    }

    try {
      const data = await this.userProvider.alterarSenha(form.senhaatual, form.senha).toPromise();

      if (data.error) {
        const alert = await this.alertCtrl.create({
          cssClass: "alerta-personalizado",
          mode: "ios",
          header: this.translate.instant('Erro'),
          subHeader: this.translate.instant(data.message),
          buttons: ['OK']
        });
        await alert.present();
      } else {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant('Senha alterada com sucesso!'),
          duration: 3000
        });
        await toast.present();
        this.modalCtrl.dismiss();
      }
    } catch (error) {
      console.error('Erro ao alterar a senha:', error);
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
